import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Compare from './Compare.vue'
import AppHeaderForCompare from '../../components/layout/AppHeaderForCompare.vue'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/compare/:compareId/:raceId',
      name: 'compare',
      components: {
        default: Compare,
        header: AppHeaderForCompare,
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
